.root {
  background-color: var(--color-ds-surface-transparent);
}

.root:focus-visible {
  outline-style: none;
  box-shadow: var(--shadow-ds-focus-ring);
}

.track-on {
  background-color: var(--color-ds-toggle-track-on);
  border-color: var(--color-ds-toggle-border-on);
}

.track-on-success {
  background-color: var(--color-ds-toggle-track-on-success);
  border-color: var(--color-ds-toggle-border-on-success);
}

.track-off-md {
  background-color: var(--color-ds-toggle-track-off);
  border-color: var(--color-ds-toggle-border-off);
}

.track-off-sm {
  background-color: var(--color-ds-toggle-track-off);
  border-color: var(--color-ds-border-transparent);
}

.track-off-lg {
  background-color: var(--color-ds-toggle-track-off);
  border-color: var(--color-ds-toggle-border-off);
}

.root-disabled {
  opacity: var(--opacity-ds-muted);
}

.thumb {
  background-color: var(--color-ds-toggle-thumb);
  box-shadow: var(--shadow-ds-toggle-thumb);
}
